import React from 'react'
import styled from 'styled-components'
import { changeTopic } from '../../store/actions/topicActions'
import { connect } from 'react-redux'

const NavbarTopicsContainer = styled.div`
  text-align: center;
  padding: 10px 0;
`
const NavbarTopicHeader = styled.h2`
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 20px;
  font-weight: "bold";
  color: black;
`
const NavbarTopic = styled.button`
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 16px;
  font-weight: "light";
  color: black;
  :hover {
    color: green;
  }
`

const NavFilter = (props) => {
  const { changeTopic } = props;
  
  return (
    <NavbarTopicsContainer>
        <NavbarTopicHeader>Filter by Topic</NavbarTopicHeader>
        <NavbarTopic onClick={() => {changeTopic("Code")}}>Code</NavbarTopic>
        <NavbarTopic onClick={() => {changeTopic("Photography")}}>Photography</NavbarTopic>
        <NavbarTopic onClick={() => {changeTopic("Videography")}}>Videography</NavbarTopic>
        <NavbarTopic onClick={() => {changeTopic("Music")}}>Music</NavbarTopic>
        <NavbarTopic onClick={() => {changeTopic("Food")}}>Food</NavbarTopic>
        <NavbarTopic onClick={() => {changeTopic("")}}>All</NavbarTopic>
    </NavbarTopicsContainer>
  )
}

const mapDispatchToProps = dispatch => {
  return {
    changeTopic: (topic) => dispatch(changeTopic(topic))
  }
}

export default connect(null, mapDispatchToProps)(NavFilter)



// WEBPACK FOOTER //
// ./src/components/navbar/NavFilter.js